
import { withStyles } from 'tss-react/mui';
import EDTypography from '../../BaseComponents/Typography/EDTypography';
import EDIconButton from '../../BaseComponents/Buttons/IconButton/EDIconButton';
import { useToggle } from '../../Hooks/booleanHooks';
import { CommonPropsAndTypes } from '../../BaseComponents/_Types/StandardComponentProps';
import Dialog from '../../BaseComponents/Dialog/EDDialog';

interface IProps {
  text: string | React.ReactNode;
  dialogTitle: string;
  title?: string;
  textColor?: CommonPropsAndTypes.ColorType | 'default';
  buttonSize?: CommonPropsAndTypes.StandardSizesType;
  buttonColor?: CommonPropsAndTypes.ColorType;
  buttonMargin?: CommonPropsAndTypes.StandardSpacingType;
  buttonPadding?: CommonPropsAndTypes.StandardSpacingType;
  buttonNoTopMargin?: boolean;
  buttonNoBottomMargin?: boolean;
  tooltipText?: string;
  classes?: any;
}

const styles = {
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  inline: {
    display: 'inline',
    whiteSpace: 'nowrap',
  },
};

/**
 * En text med en ikon för ytterligare information.
 * Denna öppnar upp en dialog för att kunna visa upp detaljerad information utan att störa huvudvyn.
 */
export const InfoText: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [dialogOpen, toggleDialogOpen] = useToggle();
  return (
    <div className={props.classes.flexContainer}>
      {props.title && (
        <EDTypography
          className={props.classes.inline}
          color={
            props.textColor
              ? props.textColor === 'default'
                ? 'initial'
                : props.textColor
              : 'textPrimary'
          }
          bold
        >
          {props.title}
          &nbsp;
        </EDTypography>
      )}
      {typeof props.text === 'string' ? (
        <EDTypography
          variant="body2"
          className={props.classes.inline}
          color={
            props.textColor
              ? props.textColor === 'default'
                ? 'initial'
                : props.textColor
              : 'textPrimary'
          }
        >
          {props.text}
        </EDTypography>
      ) : (
        props.text
      )}
      <EDIconButton
        icon="info"
        onClick={toggleDialogOpen}
        tooltip={props.tooltipText ? props.tooltipText : ''}
        iconSize={props.buttonSize ? props.buttonSize : undefined}
        color={props.buttonColor ? props.buttonColor : 'secondary'}
        margin={props.buttonMargin ? props.buttonMargin : 'dense'}
        padding={props.buttonPadding ? props.buttonPadding : 'none'}
        noTopMargin={props.buttonNoTopMargin ? props.buttonNoTopMargin : true}
        noBottomMargin={
          props.buttonNoBottomMargin ? props.buttonNoBottomMargin : true
        }
      />
      <Dialog
        open={dialogOpen}
        title={props.dialogTitle}
        onClose={toggleDialogOpen}
        footerActions={[{ onClick: toggleDialogOpen, label: 'Stäng' }]}
      >
        {props.children}
      </Dialog>
    </div>
  );
};

export default withStyles(InfoText, styles);
